import { render, staticRenderFns } from "./SampleFeesPreviewForm.vue?vue&type=template&id=54206717&scoped=true&"
import script from "./SampleFeesPreviewForm.vue?vue&type=script&lang=ts&"
export * from "./SampleFeesPreviewForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54206717",
  null
  
)

export default component.exports